import type { TStencilStoreSettings } from '../../types/Stencil';

const initialState: TStencilStoreSettings = {
  allowSharing: false,
  cancelRedirectUrl: '',
  updatingExistingSubmission: false
};

function settings(state: TStencilStoreSettings = initialState, _action) {
  return state;
}

export default settings;
